import React from "react";
import CustomTable from "../../components/CustomTable";
import { getGenre, getStates } from "../../../services/CommonServices";
import { genreValidationSchema } from "../../../utils/validationSchemas/MasterDataSchema";
import AddUpdateGenre from "./AddUpdate";

const Genre = () => {
  const columns = [
    {
      label: "#",
      render: (row, index, currentPage, pageSize) => (
        <span>{(currentPage - 1) * pageSize + index + 1}</span>
      ),
    },
    {
      label: "Genre Name",
      key: "name",
    },
    {
      label: "Art Form",
      render: (row, index) => (
        <span>{row.category.map((item) => item.name).join(", ")}</span>
      ),
    },
  ];
  const modalConfig = {
    initialValues: {
      category: "",
      name: "",
    },
    validationSchema: genreValidationSchema,
    apiUrl: "master/genre",
    FormComponent: AddUpdateGenre,
    addTitle: "Add Genre",
    updateTitle: "Update Genre",
    extraProps: {
      relationKeys: ["category"],
    },
  };
  return (
    <CustomTable
      formModal={true}
      title="Genres"
      addBtnTitle="Add New Genre"
      columns={columns}
      getHook={getGenre}
      store={"genre"}
      deleteHook={"master/genre"}
      modalConfig={modalConfig}
      search={true}
    />
  );
};

export default Genre;
